module.exports = __webpack_public_path__ + "img/1_022.f3b75870.png";